import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ItemList from 'flarum/common/utils/ItemList';
import humanTime from 'flarum/common/helpers/humanTime';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import tagIcon from '../../common/helpers/tagIcon';
import tagLabel, { tagDisplayText } from '../../common/helpers/tagLabel';
import sortTags from '../../common/utils/sortTags';
export default class TagsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "tags", void 0);
    _defineProperty(this, "loading", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('tags', extractText(app.translator.trans('flarum-tags.forum.header.back_to_tags_tooltip')));
    app.current.set('noTagsList', true);
    this.tags = [];
    const preloaded = app.preloadedApiDocument();
    if (preloaded) {
      this.tags = sortTags(preloaded.filter(tag => !tag.isChild()));
      return;
    }
    this.loading = true;
    app.tagList.load(['children', 'lastPostedDiscussion', 'parent']).then(() => {
      this.tags = sortTags(app.store.all('tags').filter(tag => !tag.isChild()));
      this.loading = false;
      m.redraw();
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(extractText(app.translator.trans('flarum-tags.forum.all_tags.meta_title_text')));
    app.setTitleCount(0);
  }
  view() {
    return m(PageStructure, {
      className: "TagsPage Page--vertical",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this)
    }, this.contentItems().toArray());
  }
  contentItems() {
    const items = new ItemList();
    if (this.loading) {
      items.add('loading', m(LoadingIndicator, null));
    } else {
      const pinned = this.tags.filter(tag => tag.position() !== null);
      const cloud = this.tags.filter(tag => tag.position() === null);
      items.add('tagTiles', this.tagTileListView(pinned), 100);
      if (cloud.length) {
        items.add('cloud', this.cloudView(cloud), 10);
      }
    }
    return items;
  }
  hero() {
    return m(WelcomeHero, null);
  }
  sidebar() {
    return m(IndexSidebar, null);
  }
  tagTileListView(pinned) {
    return m("ul", {
      className: "TagTiles"
    }, pinned.map(this.tagTileView.bind(this)));
  }
  tagTileView(tag) {
    const lastPostedDiscussion = tag.lastPostedDiscussion();
    const children = sortTags(tag.children() || []);
    return m("li", {
      className: classList('TagTile', {
        colored: tag.color()
      }, textContrastClass(tag.color())),
      style: {
        '--tag-bg': tag.color()
      }
    }, m(Link, {
      className: "TagTile-info",
      href: app.route.tag(tag)
    }, m("div", {
      className: "TagTile-heading"
    }, tag.icon() && tagIcon(tag, {}, {
      useColor: false
    }), m("h3", {
      className: "TagTile-name"
    }, tagDisplayText(tag))), m("p", {
      className: "TagTile-description"
    }, tag.description()), !!children && m("div", {
      className: "TagTile-children"
    }, children.map(child => [m(Link, {
      href: app.route.tag(child)
    }, tagDisplayText(child)), ' ']))), lastPostedDiscussion ? m(Link, {
      className: "TagTile-lastPostedDiscussion",
      href: app.route.discussion(lastPostedDiscussion, lastPostedDiscussion.lastPostNumber())
    }, m("span", {
      className: "TagTile-lastPostedDiscussion-title"
    }, lastPostedDiscussion.title()), humanTime(lastPostedDiscussion.lastPostedAt())) : m("span", {
      className: "TagTile-lastPostedDiscussion"
    }));
  }
  cloudView(cloud) {
    return m("div", {
      className: "TagCloud"
    }, cloud.map(tag => [tagLabel(tag, {
      link: true
    }), ' ']));
  }
}
flarum.reg.add('abdulrehman-tags', 'forum/components/TagsPage', TagsPage);